/*
* Project: LegalPlace assistant
* File: src/components/buy/pack_choice.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePack } from '../../redux/actions/checkout_operations';
import { PackShimmer } from '../misc/shimmer';
import { lpPattern, P_SELECT_PACK_1, P_SELECT_PACK_2 } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import {AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID} from '../../constants/subscription_constant'

/**
 *
 * @param {string} price
 */
export const percentagePromo = (price) => {
  if (Number.isNaN(parseFloat(price)) || typeof price === 'string') return 1.0;
  return 1.0 - parseFloat(price);
};

/**
 * @description The component that selects the packs of prices.
 */
class _PackChoice extends Component {
  componentWillMount() {
    document.body.classList.add('checkout-base');
  }

  componentWillUnmount() {
    document.body.classList.remove('checkout-base');
  }

  render() {
    const showSubscribeOffer = lpApp.subscription || (!lpApp.paidSession && AVAILABLE_SUBSCRIPTION_CONTRACT_META_ID.indexOf(lpApp.contractMetaId) > -1)
    if (showSubscribeOffer) lpApp.setSubscription(true)
    return (
      <div>
      {lpApp.contractMetaId === 302 ? '' :
          (<ul className={(lpApp.references.customs.custom && lpApp.references.customs.custom.uniqpack) ? 'packs one-pack' : 'packs'}>


            { (lpApp.references.customs.custom && lpApp.references.customs.custom.uniqpack) ? '' : (this.props.pricing_loading) ? <PackShimmer /> : (
          <li onClick={(e) => { e.preventDefault(); this.props.selectOne(); }} style={{opacity: showSubscribeOffer && this.props.chosen_pack === 1 ? 0.6 : 1}} className={`pack lp-checkbox pack-basic${(this.props.chosen_pack === 0) ? ' selected' : ''}`}>
            <input name="p" type="radio" id="p1" checked={this.props.chosen_pack === 0} onChange={() => {}} />
            <label htmlFor="p1">
              <div>
                <h3 className="pack-name">{lpApp.references.customs.get('first_pack_name') === 'NONE' ? _lp('Pack Basique') : lpApp.references.customs.get('first_pack_name')}</h3>
                <h4 className="pack-price">
                  {(parseFloat(this.props.first_price)
                    * percentagePromo(this.props.promo_percentage)).toFixed(2)}
€
                </h4>
              </div>
              {lpApp.references.customs.get('first_pack_content') === 'NONE'
                ? (
                  <ul className="pack-features">
                    <li>{_lp('Votre document personnalisé')}</li>
                    <li>
                      {_lp('Version imprimable ')}
                      <b>{_lp('(PDF)')}</b>
                    </li>
                    <li style={{ textDecoration: 'line-through' }} className="pack-feature-off">
                      {_lp('Version modifiable ')}
                      <b>{_lp('(Word)')}</b>
                    </li>
                    <li>{_lp('Annexes')}</li>
                    <li className="feature-highlight">
                      {_lp('Modifiable pendant ')}
                      <span className="ped-hilight">{_lp('15 jours')}</span>
                    </li>
                  </ul>
                ) : <ul className="pack-features" dangerouslySetInnerHTML={{ __html: lpApp.references.customs.get('first_pack_content') }} />
                        }
            </label>
          </li>
        )}

        {this.props.pricing_loading ? <PackShimmer /> : (
          showSubscribeOffer ?
          (
            <li onClick={(e) => { e.preventDefault(); this.props.selectSubscription(); }} className={`pack lp-checkbox pack-complet${(this.props.chosen_pack === 1) ? ' selected' : ''}`}>
            <input name="p" type="radio" id="p2" checked={this.props.chosen_pack === 1} onChange={() => {}} />
            <label htmlFor="p2">
              <div>
                <h3 className="pack-name">{_lp('Essai 7 jours')}</h3>
                <h4 className="pack-price">
                  <span>
                    {_lp('Gratuit')}
                  </span>
                </h4>
              </div>
                  <ul className="pack-features">
                    <li>{_lp('Votre document personnalisé en ')}<b>{_lp('Word')}</b>{_lp(' et ')}<b>{_lp('PDF')}</b>{_lp(' avec annexes')}</li>
                    <li>
                      {_lp('Accès illimité et gratuit à la bibliothèque de documents juridiques LegalPlace')}
                    </li>
                    <li>
                      {_lp('Support juridique gratuit')}
                    </li>
                    <li>{_lp('Gratuit 7 jours puis ')}<b>{_lp('19,90€/mois.')}</b><br/>{_lp('Annulable sans aucun frais à tout moment')}</li>
                  </ul>
            </label>
          </li>
          )
          : (
            <li onClick={(e) => { e.preventDefault(); this.props.selectTwo(); }} className={`pack lp-checkbox pack-complet${(this.props.chosen_pack === 1) ? ' selected' : ''}`}>
                    {(lpApp.references.customs.custom && lpApp.references.customs.custom.uniqpack) ? '' : <div className="pack-badge">{_lp('Le plus populaire')}</div> }
            <input name="p" type="radio" id="p2" checked={this.props.chosen_pack === 1} onChange={() => {}} />
            <label htmlFor="p2">
              <div>
                <h3 className="pack-name">{lpApp.references.customs.get('second_pack_name') === 'NONE' ? _lp('Pack Complet') : lpApp.references.customs.get('second_pack_name')}</h3>
                <h4 className="pack-price">
                  <span>

                    {(parseFloat(this.props.second_price)
                    * percentagePromo(this.props.promo_percentage)).toFixed(2)}
€
                  </span>
                  <span className="pack-price-original">
                    {(parseFloat(this.props.second_price) + 15).toFixed(2)}
€
                  </span>
                </h4>
              </div>
              {lpApp.references.customs.get('second_pack_content') === 'NONE'
                ? (
                  <ul className="pack-features">
                    <li>{_lp('Votre document personnalisé')}</li>
                    <li>
                      {_lp('Version imprimable ')}
                      <b>{_lp('(PDF)')}</b>
                    </li>
                    <li>
                      {_lp('Version modifiable ')}
                      <b>{_lp('(Word)')}</b>
                    </li>
                    <li>Annexes</li>
                    <li className="feature-highlight">
                      {_lp('Modifiable pendant ')}
                      <span className="ped-hilight">{_lp('45 jours')}</span>
                    </li>
                  </ul>
                ) : <ul className="pack-features" dangerouslySetInnerHTML={{ __html: lpApp.references.customs.get('second_pack_content') }} />
                        }
            </label>
          </li>

          )
        )}


      </ul>)
      }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  chosen_pack: state.checkout_operations.pack,
  pricing_loading: state.loading_details.pricing,
  promo_percentage: state.checkout_operations.promo_percentage,
});

const mapDispatchToProps = dispatch => ({
  selectSubscription: () => {
    dispatch(ckUpdatePack(1))
    lpPattern.trackInPayment(P_SELECT_PACK_2);
  },
  selectOne: () => {
    dispatch(ckUpdatePack(0));
    lpPattern.trackInPayment(P_SELECT_PACK_1);
  },
  selectTwo: () => {
    dispatch(ckUpdatePack(1));
    lpPattern.trackInPayment(P_SELECT_PACK_2);
  },
});

export const PackChoice = connect(mapStateToProps, mapDispatchToProps)(_PackChoice);



// WEBPACK FOOTER //
// ./src/components/buy/pack_choice.js